module.exports = __webpack_public_path__ + "media/assets/images/lib/content-tools/video-7dc294d589960bf9460630fcb27586b7.png";